export default {
    install(Vue){
        Vue.prototype.$inputWidth = '200px'
        Vue.prototype.$selectWidth = '200px'
        Vue.prototype.$timeSelectWidth = '200px'
        Vue.prototype.$datePickerWidth = '200px'
    }
}